/**
 * "Essen" opens where the person left it (Mike, 16.10.: "Am besten er merkt sich die letzte
 * Einstellung des Toggles oder immer sonst auf den ersten"). Per device, nothing to sync – a
 * blocked storage simply means the first tab.
 */
const KEY = 'shh.foodTab';
export const FOOD_TABS = ['/essen/heute', '/essen/woche', '/essen/rezepte', '/essen'] as const;

export function rememberFoodTab(path: string) {
  if (!(FOOD_TABS as readonly string[]).includes(path)) return;
  try {
    localStorage.setItem(KEY, path);
  } catch {
    /* private mode: the first tab next time */
  }
}

/** The tab "Essen" opens: the last one used, else the first one the person can see. */
export function foodTabHref(first: string): string {
  try {
    const last = localStorage.getItem(KEY);
    if (last && (FOOD_TABS as readonly string[]).includes(last)) return last;
  } catch {
    /* fall through */
  }
  return first;
}
